//Contact Module const
export const TOGGLE_COLLAPSED_NAV = 'toggle_collapse_menu';
export const DRAWER_TYPE = 'drawer_type';
export const FIXED_DRAWER = 'fixed_drawer';
export const COLLAPSED_DRAWER = 'collapsible';
export const MINI_DRAWER = 'mini_drawer';
export const THEME_COLOR = 'theme_color';
export const WINDOW_WIDTH = 'window-width';

export const DISPLAY_ERROR = 'DISPLAY_ERROR';
export const DISPLAY_WARNING = 'DISPLAY_WARNING';
export const DISPLAY_SUCCESS = 'DISPLAY_SUCCESS';
export const DISPLAY_DONE = 'DISPLAY_DONE';


export const UPLOAD_FILE_REQUEST = 'UPLOAD_FILE_REQUEST';
export const UPLOAD_FILE_REQUEST_COMPLETED = 'UPLOAD_FILE_REQUEST_COMPLETED';
export const UPLOAD_FILE_REQUEST_ERROR = 'UPLOAD_FILE_REQUEST_ERROR';
export const UPLOAD_FILE_RESET = 'UPLOAD_FILE_RESET';

export const DOWNLOAD_PHOTO_REQUEST = 'DOWNLOAD_PHOTO_REQUEST';
export const DOWNLOAD_PHOTO_REQUEST_COMPLETED = 'DOWNLOAD_PHOTO_REQUEST_COMPLETED';
export const DOWNLOAD_PHOTO_REQUEST_ERROR = 'DOWNLOAD_PHOTO_REQUEST_ERROR';
export const DOWNLOAD_PHOTO_RESET = 'DOWNLOAD_PHOTO_RESET';


// WEBPACK FOOTER //
// ./constants/ActionTypes.js